/**
 * Initializes the product grid with a "load more" button.
 *
 * This function sets up an event listener on elements with the class "js-load-more-products".
 * When the button is clicked, it will show the next set of hidden products and update the product count.
 * If all products are shown, the button will be hidden.
 */
const initializePdProductGrid = () => {
    let $pdProductGrid = $(".js-pd-product-grid");

    if (!$pdProductGrid.length) {
        return;
    }

    $pdProductGrid.each(() => {
        let $loadMoreButton = $(".js-load-more-products");
        let totalCount = parseInt($pdProductGrid.data("total-count"), 10);

        if ($loadMoreButton && $pdProductGrid) {
            $loadMoreButton.on("click", () => {
                // Show the next set of products
                let $hiddenProducts = $pdProductGrid.find(".pd-tile-wrap.d-none");
                $hiddenProducts.removeClass("d-none");

                // Updates the product count.
                let currentCount = $pdProductGrid.find(".pd-tile-wrap:not(.d-none)").length;
                let $pdProductGridCounter = $(".js-pd-product-grid-counter");

                if ($pdProductGridCounter) {
                    let gridCountMessage = `${currentCount} de ${totalCount} produtos`;
                    $pdProductGridCounter.text(gridCountMessage);
                }

                // Hides the button if all products are shown.
                if (currentCount >= totalCount) {
                    $loadMoreButton.hide();
                }
            });
        }
    });
};

module.exports = {
    initializePdProductGrid: initializePdProductGrid
};
